import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-title section-container background-gray q-py-lg" }
const _hoisted_2 = { class: "section-container row q-pt-lg" }
const _hoisted_3 = { class: "col-3" }
const _hoisted_4 = { class: "offset-1 col-8" }
const _hoisted_5 = { class: "flex items-center justify-between q-mb-lg" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "page-subtitle" }, "Payment data", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "section-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line q-my-lg" })
], -1)
const _hoisted_8 = { class: "section-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GeneralInfo = _resolveComponent("GeneralInfo")!
  const _component_Passwords = _resolveComponent("Passwords")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_AddPaymentSystemDialog = _resolveComponent("AddPaymentSystemDialog")!
  const _component_PaymentSystemAccounts = _resolveComponent("PaymentSystemAccounts")!
  const _component_Naming = _resolveComponent("Naming")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, { class: "q-mb-lg" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('profile')), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_GeneralInfo),
          _createVNode(_component_Passwords)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_q_btn, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAddPaymentSystemDialog = true)),
              "no-caps": "",
              unelevated: "",
              label: "Add",
              "icon-right": _ctx.heroOutline24Plus,
              color: "primary",
              class: "q-btn__main-size text-weight-bold"
            }, null, 8, ["icon-right"]),
            _createVNode(_component_AddPaymentSystemDialog, {
              open: _ctx.showAddPaymentSystemDialog,
              onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAddPaymentSystemDialog = false))
            }, null, 8, ["open"])
          ]),
          _createVNode(_component_PaymentSystemAccounts, { "is-inline": "true" })
        ])
      ]),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Naming)
      ])
    ]),
    _: 1
  }))
}